import { ActionComponent } from './payment-hub/action/action.component';
import { CommonModule } from '@angular/common';
import { CustomerComponent } from './customer/customer.component';
import { NgModule } from '@angular/core';
import { OTPComponent } from './otp/otp.component';
import { PaymentComponent } from './payment-hub/payment/payment.component';
import { RecurringComponent } from './payment-hub/recurring/recurring.component';
import { Routes, RouterModule } from '@angular/router';
import { WalletComponent } from './payment-hub/wallet/wallet.component';

const routes: Routes = [
  { path: '', redirectTo: '/customer', pathMatch: 'full' },
  { path: 'customer', component: CustomerComponent, children: [
      { path: 'wallet', component: WalletComponent },
      { path: 'recurring', component: RecurringComponent },
      { path: 'payment', component: PaymentComponent },
    ] },
  { path: 'otp', component: OTPComponent },
  { path: 'action', component: ActionComponent },
  { path: 'callback', component: ActionComponent },
  { path: '**', redirectTo: '/customer' },
];

@NgModule({
  declarations: [],
  imports: [
    CommonModule, RouterModule.forRoot(routes,  {
    onSameUrlNavigation: 'reload',
    relativeLinkResolution: 'legacy'
})
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }
